import React from 'react'

const TopTip = (props) => {
  return (
    <div className='top-tip'>
      <h3>Top tips:</h3>
      {/* {props.templateType === 'tel_councilReportHarassment' ||  props.templateType === 'tel_councilEvictionNotice' ? (
       <>
       <ul>
          <li><p>Remember to speak slowly, clearly and calmly. </p></li>
          <li><p>If you leave a voicemail, give your name and number at the start of the message and again at the end.</p></li>
         </ul>
         {props.templateType !== 'tel_councilEvictionNotice' ?
         <p>You can use these prompts to phone the council to report harassment by your landlord/letting agent.<br/>It can be hard to get through to the council, so keep trying.</p>  
         : null }
        </>
      ) : ( */}
      {props.toolsData && props.toolsData.length > 0 ? (
        <ul>
          {props.toolsData.map((tool, index) => {
            if (props.templateType === 'tel_councilReportHarassment' && index === 2) {
              return (
                <p key={index}>{tool}</p>
              );
            } else {
              return (
                <li key={index}>
                  <p>{tool}</p>
                </li>
              );
            }
          })}
        </ul>
      ) : null }
      {/* <ul className='mb-0'>
        <li><p>Know your schedule so you can agree a time for them to inspect the property if necessary. </p></li>
        <li><p>Remember to speak slowly, clearly, and calmly.</p></li>
        <li><p>If you leave a voicemail, leave your name and telephone number at the beginning of the message, and repeat it at the end. </p></li>
        <li><p>Be prepared to take notes of what the landlord / letting agent says so you have a record of your conversation.</p></li>
      </ul> */}
    {/* ) } */}
    </div>
  )
}

export default TopTip
